import React, { useState, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Big from 'big.js';
import { comparePropsIgnoringFunctions } from 'helpers/memo';
import Headers from './Headers';
import sharedStyles from '../styles.module.scss';
import styles from './styles.module.scss';
import TradesWithDates from './TradesWithDates';

Big.RM = 0;

function TradeHistory({ trades, market }) {
  const [enableAnimation, setEnableAnimation] = useState(false);

  useEffect(() => {
    return () => {
      if (trades.length > 0 && !enableAnimation) {
        setEnableAnimation(true);
      }
    };
  }, [trades, enableAnimation]);

  return (
    <table
      role="grid"
      aria-label="trade-history"
      className={classnames(sharedStyles.table, { [styles.enabledAnimation]: enableAnimation })}>
      <Headers />
      <tbody className={sharedStyles.tbody} style={{ overflowY: 'none' }}>
        <TradesWithDates trades={trades} market={market} />
      </tbody>
    </table>
  );
}

TradeHistory.propTypes = {
  trades: PropTypes.array.isRequired,
  market: PropTypes.object
};

TradeHistory.defaultProps = {
  market: null
};

export default memo(TradeHistory, comparePropsIgnoringFunctions);
